import React, { useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import Select from "react-select";

import {
  creaPermisos,
  obtenerReportePorId,
  obtenerUsuarios,
} from "../../Services/Rest";

ReactModal.setAppElement("#root");

function CrearPermisos() {
  const cookie = new Cookies();

  const [isOpen, setIsOpen] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [reportes, setReportes] = useState([]);

  const [usuario, setUsuario] = useState(null);
  const [reporte, setReporte] = useState(null);

  // 🔹 Cargar usuarios
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenerUsuarios + cookie.get("ID"),
    })
      .then((res) => {
        const data = res.data.map((u) => ({
          value: u.id,
          label: u.nombre,
        }));
        setUsuarios(data);
      })
      .catch(console.log);
  }, []);

  // 🔹 Cargar reportes
  useEffect(() => {
    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "get",
      url: obtenerReportePorId + cookie.get("ID"),
    })
      .then((res) => {
        const data = res.data.map((r) => ({
          value: r.id,
          label: r.reporte,
        }));
        setReportes(data);
      })
      .catch(console.log);
  }, []);

  // 🔥 Guardar
  const postData = (e) => {
    e.preventDefault();

    if (!usuario || !reporte) {
      return Swal.fire(
        "Campos requeridos",
        "Seleccione usuario y reporte",
        "warning",
      );
    }

    axios({
      auth: { username: "webapp", password: "762tsfsy9826kk87ytttsf" },
      method: "post",
      url: creaPermisos,
      data: {
        idUsuario: usuario.value,
        idReporte: reporte.value,
      },
    })
      .then((res) => {
        setIsOpen(false); // 🔥 cerrar modal antes

        Swal.fire({
          title: "Éxito",
          text: res.data,
          icon: "success",
          confirmButtonText: "Aceptar",
        }).then(() => {
          window.location.reload();
        });
      })
      .catch(() => {
        setIsOpen(false);

        Swal.fire("Error", "No se pudo guardar", "error");
      });
  };

  return (
    <div>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        + Nuevo Permiso
      </button>

      <ReactModal
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        className="modal-xl"
        overlayClassName="overlay-xl"
      >
        {/* HEADER */}
        <div className="modal-header-xl">
          <h3>Crear Permiso</h3>
          <button onClick={() => setIsOpen(false)}>✕</button>
        </div>

        {/* FORM */}
        <form className="modal-body-xl" onSubmit={postData}>
          <div className="grid-form">
            <div>
              <label>Usuario</label>
              <Select
                options={usuarios}
                value={usuario}
                onChange={setUsuario}
                placeholder="Buscar usuario..."
                isSearchable
              />
            </div>

            <div>
              <label>Reporte</label>
              <Select
                options={reportes}
                value={reporte}
                onChange={setReporte}
                placeholder="Buscar reporte..."
                isSearchable
              />
            </div>
          </div>

          <div className="actions-xl">
            <button type="button" onClick={() => setIsOpen(false)}>
              Cancelar
            </button>

            <button type="submit" className="btn-save-xl">
              Guardar
            </button>
          </div>
        </form>
      </ReactModal>
    </div>
  );
}

export default CrearPermisos;
